import { Coordinate } from '@/@types'
import { batters } from '@/components/CakeMaker/data/batters'
import { TRADITIONAL_PRICE } from '@/components/CakeMaker/data/fillings'
import { weights } from '@/components/CakeMaker/data/weights'
import { formatMoney } from '@/utils'

export const ORIGIN_COORDINATES: Coordinate = Object.freeze({
  latitude: -23.571849833079437,
  longitude: -46.47644011953156,
})

// Domínio canônico. O site é servido em www.sanctafatia.com — não usar
// sanctafatia.com.br, que não resolve em DNS.
export const SITE_URL = 'https://www.sanctafatia.com'

// Fonte única do NAP: usado no link do WhatsApp, no rodapé e no JSON-LD.
// Deve bater exatamente com o Google Business Profile e o Instagram.
export const CONTACT = Object.freeze({
  PHONE_E164: '+5511991162637',
  PHONE_DIGITS: '5511991162637',
  PHONE_DISPLAY: '(11) 99116-2637',
  POSTAL_CODE: '08275-150',
})

// Raio de entrega, em quilômetros rodados. Fonte única: alimenta o limite da
// API de distância, o geoRadius do schema e o texto do site — antes cada um
// declarava um valor diferente (30 km, 15 km e "toda zona leste").
export const DELIVERY_RADIUS_KM = 18

// Bairros citados nominalmente no site. "Toda a Zona Leste" não permite que um
// LLM responda "vocês entregam em Itaquera?". A lista é ilustrativa — quem
// decide a cobertura de fato é o cálculo de DELIVERY_RADIUS_KM.
export const SERVED_NEIGHBORHOODS: ReadonlyArray<string> = Object.freeze([
  'Parque do Carmo',
  'Jardim Nossa Senhora do Carmo',
  'Cidade Líder',
  'Itaquera',
  'José Bonifácio',
  'São Mateus',
  'Sapopemba',
  'Aricanduva',
  'Vila Formosa',
  'Carrão',
  'Vila Matilde',
  'Artur Alvim',
  'Penha',
  'Guaianases',
  'Itaim Paulista',
  'São Miguel Paulista',
  'Ermelino Matarazzo',
  'Tatuapé',
])

// Prazo mínimo entre o pedido e a entrega. O calendário do montador bloqueia
// as datas dentro desse prazo; os textos do site citam o mesmo número.
export const MIN_NOTICE_DAYS = 7

// Valor fixo do topo personalizado, cobrado quando o cliente define um tema.
export const THEME_PRICE = 24.99

// Preço de referência anunciado no site: bolo de 1 kg com a massa mais barata
// e um recheio tradicional (o recheio é obrigatório no montador). Calculado a
// partir dos dados do montador para não desatualizar quando um preço mudar.
const REFERENCE_WEIGHT = weights.find((weight) => weight.value === '1kg')!
const CHEAPEST_BATTER_PRICE = Math.min(...batters.map(({ price }) => price))
const STARTING_PRICE_VALUE =
  Math.round(
    (CHEAPEST_BATTER_PRICE + TRADITIONAL_PRICE) *
      REFERENCE_WEIGHT.multiplication_factor *
      100,
  ) / 100

export const STARTING_PRICE = Object.freeze({
  VALUE: STARTING_PRICE_VALUE,
  DISPLAY: formatMoney(STARTING_PRICE_VALUE),
  REFERENCE: `${REFERENCE_WEIGHT.value}, ${REFERENCE_WEIGHT.description}`,
})

const WHATSAPP_MESSAGE =
  'Olá! Gostaria de encomendar com a Sancta Fatia.' as const

export const LINKS = Object.freeze({
  PINTEREST_URL: 'https://www.instagram.com/sanctafatia/',
  INSTAGRAM_URL: 'https://www.instagram.com/sanctafatia/',
  ORDER_WHATSAPP_URL: `https://wa.me/${CONTACT.PHONE_DIGITS}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`,
})
